import { render, staticRenderFns } from "./getFromTo.vue?vue&type=template&id=4cf1976e&scoped=true"
import script from "./getFromTo.vue?vue&type=script&lang=js"
export * from "./getFromTo.vue?vue&type=script&lang=js"
import style0 from "./getFromTo.vue?vue&type=style&index=0&id=4cf1976e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf1976e",
  null
  
)

export default component.exports